module.exports = __webpack_public_path__ + "static/media/moistrol-4.73df18c0.jpg";